import { __ } from '~/javascripts/lib/locale';
import {
  GITLAB_CREDITS_PLAN_TYPE,
  DUO_SELF_HOSTED_PLAN_TYPE,
} from '~/javascripts/subscription/constants';

export const UNKNOWN_SUBSCRIPTION = 'Unknown subscription';

export const PRODUCT_SUB_TYPES = Object.freeze({
  MAIN: 'plan',
  GITLAB_DEDICATED: 'gitlab-dedicated',
  STORAGE: 'storage',
  CODE_SUGGESTIONS: 'code-suggestions',
  DUO_ENTERPRISE: 'duo-enterprise',
  PRODUCT_ANALYTICS: 'product-analytics',
  ENTERPRISE_AGILE_PLANNING: 'enterprise-agile-planning',
  CI_MINUTES: 'ci-minutes',
  TRUE_UP: 'true-up',
  PROFESSIONAL_SERVICE: 'professional-service',
  GITLAB_CREDITS: GITLAB_CREDITS_PLAN_TYPE,
  DUO_SELF_HOSTED: DUO_SELF_HOSTED_PLAN_TYPE,
});

// EXCLUDED_PRODUCT_SUB_TYPES are products which have multiple ratePlans with the same `ratePlanId`.
// Eg: 1 - Dedicated - Ultimate - 1 Year, 2 - Dedicated - Storage 10GB - 1 Year, 3 - Dedicated - Administration Fee [Small] - 1 Year
// Although 2 & 3 are classified as addon products, they still need to be displayed in the main product section. Hence we need to ignore
// these rate plans while filtering the addon product rate plans.
export const EXCLUDED_PRODUCT_SUB_TYPES = ['gitlab-dedicated', 'us-gov-sm', 'duo-amazon-q'];
export const UNMAPPED_PRODUCT_SUB_TYPE = 'UNMAPPED';

export const DATE_TENSE = Object.freeze({
  AUTO_RENEWS: 'Auto-renews',
  EXPIRES: __('Expires'),
  STARTS: __('Starts'),
  EXPIRED: __('Expired'),
});

export const RENEWAL_TYPE = Object.freeze({
  AUTO_RENEW: __('auto-renew'),
  EXPIRE: __('expire'),
});

export const MAIN_PRODUCT_CONFIGS = {
  [PRODUCT_SUB_TYPES.GITLAB_DEDICATED]: {
    priceLabel: __('Price per unit'),
  },
};

export const SUBSCRIPTION_DATE_FUTURE_START = __(
  'Your subscription will start on %{startDate} and %{renewalType} on %{endDate}.',
);
export const SUBSCRIPTION_DATE_PAST_START = __(
  'Your subscription started on %{startDate} and will %{renewalType} on %{endDate}.',
);
export const SUBSCRIPTION_DATE_EXPIRED = __('Your subscription expired on %{endDate}.');
export const SUBSCRIPTION_DATE_REACTIVATE = `${SUBSCRIPTION_DATE_EXPIRED} ${__(
  'To reactivate your subscription, renew by %{renewalExpirationDate}.',
)}`;
